import axiosMultipartInstance from "~/shared/api/axios-multipart-instance";

export const createFloorPlan = async (params: {
  branchUid: string;
  versionId?: number;
  name: string;
  image?: File;
}) => {
  const formData = new FormData();
  formData.append("name", params.name);
  if (params.image) {
    formData.append("img", params.image);
  }
  if (params.versionId != null) {
    formData.append("version", params.versionId.toString());
  }
  const { data } = await axiosMultipartInstance.post(
    `branches/${params.branchUid}/floor-plans/`,
    formData,
  );
  return data;
};
